export class Faq {
    constructor() {
        this.initEventHandlers();
    }

    initEventHandlers() {
        $(document).on('click', 'section.faq .faq-elem .top, section.faqs .faq-elem .top', this.toggleFaq.bind(this));
    }

    toggleFaq(e) {
        const faqElem = $(e.currentTarget).parents('.faq-elem');
        faqElem.toggleClass('open');
        faqElem.find('.content').slideToggle();
    }
}